import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { COMMON_CONTENT_ACTION_TYPE } from "./common-content.action";
import { CommonContentState, CommonContentSuccessPayload } from "./common-content.model";
import { getContentKey } from "./common-content.utils";

const INITIAL_STATE: CommonContentState = {
	items: {},
};

export function commonContentReducer(state = INITIAL_STATE, action: ActionWithPayload) {
	switch (action.type) {
		case COMMON_CONTENT_ACTION_TYPE.getSuccess: {
			const payload: CommonContentSuccessPayload = action.payload;
			const contentKey = getContentKey(payload);
			return updateState(state, {
				items: updateState(state.items, {
					[contentKey]: payload.commonContent,
				}),
			});
		}
		default:
			return state;
	}
}
